"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EmergencyContact = _interopRequireDefault(require("./EmergencyContact"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _EmergencyContact.default;
exports.default = _default;